let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eCOxy")).then(() => parcelRequire('9aF4A'));